<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Opinion Modified</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onAuditOpinionModifiedCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="onCreateAuditOpinionModified()">
        <mat-icon>add</mat-icon>
        Add Opinion Modified
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="auditOpinionModifieds()"
      [enableMatching]="true"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditAuditOpinionModified($event)"
      (deleteClick)="onDeleteAuditOpinionModified($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
